import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Brush = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.41731 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M20.4078 5.08759C19.0867 8.38164 15.7755 12.8595 13.0047 15.0813L11.3148 16.4366C11.1004 16.591 10.8859 16.7283 10.6457 16.8227C10.6457 16.6683 10.6371 16.4967 10.6114 16.3337C10.517 15.6131 10.1911 14.944 9.61632 14.3693C9.03299 13.786 8.321 13.4428 7.59184 13.3485C7.42028 13.3399 7.24871 13.3227 7.07715 13.3399C7.17151 13.074 7.31734 12.8252 7.49748 12.6193L8.83569 10.9294C11.0489 8.15861 15.5439 4.83024 18.8294 3.51776C19.3355 3.32904 19.8245 3.46629 20.1333 3.78369C20.4593 4.10109 20.6137 4.59005 20.4078 5.08759Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.6457 16.8226C10.6457 17.7662 10.2854 18.667 9.60768 19.3532C9.08441 19.8765 8.37241 20.2368 7.52316 20.3483L5.4129 20.5799C4.26342 20.7086 3.27692 19.7307 3.41417 18.564L3.64578 16.4538C3.85166 14.5751 5.42148 13.3742 7.08567 13.3399C7.25723 13.3313 7.43738 13.3399 7.60036 13.3484C8.32952 13.4428 9.04151 13.7773 9.62484 14.3692C10.1996 14.944 10.5256 15.6131 10.6199 16.3337C10.6285 16.4967 10.6457 16.6596 10.6457 16.8226Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.914 14.1204C13.914 11.8815 12.0954 10.0629 9.85645 10.0629",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
